
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as _91_46_46_46category_93f4WQ3ab5Xy2P5b98tbQdoCMHiui5hTEJXlBMQbZKPmoMeta } from "/var/www/vhosts/asoundeffect.com/int-httpdocs/nuxt-wp/app/pages/blog/[...category].vue?macro=true";
import { default as blogaF_GBGLllKBAyBBS_hCm0yHKSvbOwrMhT3HiRAYR618Meta } from "/var/www/vhosts/asoundeffect.com/int-httpdocs/nuxt-wp/app/pages/blog.vue?macro=true";
import { default as cartvbiT8im0rObI3ln_ZwBvWLREIAmI9JW8IXSeDlR3eAkMeta } from "/var/www/vhosts/asoundeffect.com/int-httpdocs/nuxt-wp/app/pages/cart.vue?macro=true";
import { default as _91_46_46_46pageParams_93feciOjqeIbXLlvMBGfXrHYC4zxWPpjbBBMY_hYsVFuoMeta } from "/var/www/vhosts/asoundeffect.com/int-httpdocs/nuxt-wp/app/pages/shop/[...pageParams].vue?macro=true";
import { default as shopkqS7AM_S7JjrGYGAGlEys0_NOBVGAU_lAWnqn9zjaP4Meta } from "/var/www/vhosts/asoundeffect.com/int-httpdocs/nuxt-wp/app/pages/shop.vue?macro=true";
import { default as indexjU36uj0uhu5GvMKRG9tHClmwCuBisYDQf1OO8S1sO0gMeta } from "/var/www/vhosts/asoundeffect.com/int-httpdocs/nuxt-wp/app/pages/index.vue?macro=true";
import { default as loginEC0_yRCMFhL1UvTjfQLNMhe3HYvAiUUO_RbT5I90AH8Meta } from "/var/www/vhosts/asoundeffect.com/int-httpdocs/nuxt-wp/app/pages/login.vue?macro=true";
import { default as _91_46_46_46uri_93T4g_uMnc69_z9k4uWiJTsEbHKaq8EjRcCxj50a_LxIUMeta } from "/var/www/vhosts/asoundeffect.com/int-httpdocs/nuxt-wp/app/pages/[...uri].vue?macro=true";
import { default as checkout0DDJrlhOw_r1LutdTRYjYm_FvXiGm3fmTLLObHQukEYMeta } from "/var/www/vhosts/asoundeffect.com/int-httpdocs/nuxt-wp/app/pages/checkout.vue?macro=true";
import { default as not_45foundm4xt_koojQz6uxDo3P6BqVnj0NE__M33LwGZwQWYNvIMeta } from "/var/www/vhosts/asoundeffect.com/int-httpdocs/nuxt-wp/app/pages/not-found.vue?macro=true";
import { default as indexaaJmrDWwx0b4m7ccq6dPPScW2O_H2suNfED4Z7Y_2nIMeta } from "/var/www/vhosts/asoundeffect.com/int-httpdocs/nuxt-wp/app/pages/my-account/index.vue?macro=true";
import { default as addressKyvAUBpXG7B_4B9UH2G_OQ54zhCDFeFIEYI4mjXlbDUMeta } from "/var/www/vhosts/asoundeffect.com/int-httpdocs/nuxt-wp/app/pages/my-account/address.vue?macro=true";
import { default as downloads1CTpobJe4A8vkUKqx8StzNQdx5JfYEUm4yoFWsQ_hj0Meta } from "/var/www/vhosts/asoundeffect.com/int-httpdocs/nuxt-wp/app/pages/my-account/downloads.vue?macro=true";
import { default as favoritesD_GvfZJRByYDXM2Gsu8M7y_h1jAz3VY50vrCZo_v5msMeta } from "/var/www/vhosts/asoundeffect.com/int-httpdocs/nuxt-wp/app/pages/my-account/favorites.vue?macro=true";
import { default as _91id_93LJiYAlEQkdjtnhbGzIcwbxC8lFSJfQFIy11n7TJ2GGUMeta } from "/var/www/vhosts/asoundeffect.com/int-httpdocs/nuxt-wp/app/pages/my-account/orders/[id].vue?macro=true";
import { default as address_45formcKzsAlORI3NLhBTUdwHnDO2fPQiJZ4g4LIFJ7iCFBXkMeta } from "/var/www/vhosts/asoundeffect.com/int-httpdocs/nuxt-wp/app/pages/my-account/address-form.vue?macro=true";
import { default as indexfXlmuoV1tWKm0rs3Aa2MPDQdKUAJ6oAbr1a98ketCSYMeta } from "/var/www/vhosts/asoundeffect.com/int-httpdocs/nuxt-wp/app/pages/my-account/orders/index.vue?macro=true";
import { default as account_45detailsGqRce_qY4u8WSAawivyyglC_eVB_A_r2lLK1hhfp2nsMeta } from "/var/www/vhosts/asoundeffect.com/int-httpdocs/nuxt-wp/app/pages/my-account/account-details.vue?macro=true";
import { default as payment_45methodsyQ7lofdsIctdq2IVKmToS4y5v6pfmq8UujXr1zS0qRAMeta } from "/var/www/vhosts/asoundeffect.com/int-httpdocs/nuxt-wp/app/pages/my-account/payment-methods.vue?macro=true";
import { default as add_45payment_45methodX14FhcGK2Aob_zssi3vZo9Pk1p010ACm_5WBFU4BsawMeta } from "/var/www/vhosts/asoundeffect.com/int-httpdocs/nuxt-wp/app/pages/my-account/add-payment-method.vue?macro=true";
import { default as _91id_93E4_XSp4I4OVevHxLMCf8v6oKxp_D6GidDNEM7eV7IfkMeta } from "/var/www/vhosts/asoundeffect.com/int-httpdocs/nuxt-wp/app/pages/my-account/subscriptions/[id].vue?macro=true";
import { default as indexFBqlzUuzfIf8PXU_BrUG9Ipdm7CYk_TXQibPAs4DwqIMeta } from "/var/www/vhosts/asoundeffect.com/int-httpdocs/nuxt-wp/app/pages/my-account/subscriptions/index.vue?macro=true";
import { default as my_45account3NRqaBndITRnxshN0T8SbNqzvrVqA1Et9Elgh_MjTx4Meta } from "/var/www/vhosts/asoundeffect.com/int-httpdocs/nuxt-wp/app/pages/my-account.vue?macro=true";
import { default as lost_45passwordU9RsmCA0D0_uIrCIFESn6rcCmwdRyUGUunrtOe1j3_4Meta } from "/var/www/vhosts/asoundeffect.com/int-httpdocs/nuxt-wp/app/pages/lost-password.vue?macro=true";
import { default as create_45accountFY4VLB6S8bgrdrENZP6_u_4GMhuzvQ6_6u8ZAOf6Mf8Meta } from "/var/www/vhosts/asoundeffect.com/int-httpdocs/nuxt-wp/app/pages/create-account.vue?macro=true";
import { default as _91_46_46_46uri_93q7nOglzYxqMtmUdXP5c7cn3DXifmKxD7PQYd2A4_pNEMeta } from "/var/www/vhosts/asoundeffect.com/int-httpdocs/nuxt-wp/app/pages/category/[...uri].vue?macro=true";
import { default as _91_46_46_46uri_93OqfmAXd1hOhIesStwxXZxHV7QI81Z7LXTp6vD_TgjR0Meta } from "/var/www/vhosts/asoundeffect.com/int-httpdocs/nuxt-wp/app/pages/product-tag/[...uri].vue?macro=true";
import { default as _91_46_46_46uri_93VgYhnIOQz45I10UhusuTxlAC9eiFJxHPeyXKlFMRDZEMeta } from "/var/www/vhosts/asoundeffect.com/int-httpdocs/nuxt-wp/app/pages/sound-library/[...uri].vue?macro=true";
import { default as _91_46_46_46uri_93TXWJr1pxqCHWlYvYTGfm9MsVihWMEpL4Iggtm_N2IpQMeta } from "/var/www/vhosts/asoundeffect.com/int-httpdocs/nuxt-wp/app/pages/sounddesigner/[...uri].vue?macro=true";
import { default as _91_46_46_46uri_93WCJwJGW6ZKzSXq4aNy66Ak7b0KhXuJxxugiJuQrg6lAMeta } from "/var/www/vhosts/asoundeffect.com/int-httpdocs/nuxt-wp/app/pages/sound-category/[...uri].vue?macro=true";
export default [
  {
    name: "blog",
    path: "/blog",
    component: () => import("/var/www/vhosts/asoundeffect.com/int-httpdocs/nuxt-wp/app/pages/blog.vue"),
    children: [
  {
    name: "blog-category",
    path: ":category(.*)*",
    component: () => import("/var/www/vhosts/asoundeffect.com/int-httpdocs/nuxt-wp/app/pages/blog/[...category].vue")
  }
]
  },
  {
    name: "cart",
    path: "/cart",
    component: () => import("/var/www/vhosts/asoundeffect.com/int-httpdocs/nuxt-wp/app/pages/cart.vue")
  },
  {
    name: "shop",
    path: "/shop",
    component: () => import("/var/www/vhosts/asoundeffect.com/int-httpdocs/nuxt-wp/app/pages/shop.vue"),
    children: [
  {
    name: "shop-pageParams",
    path: ":pageParams(.*)*",
    component: () => import("/var/www/vhosts/asoundeffect.com/int-httpdocs/nuxt-wp/app/pages/shop/[...pageParams].vue")
  }
]
  },
  {
    name: "index",
    path: "/",
    component: () => import("/var/www/vhosts/asoundeffect.com/int-httpdocs/nuxt-wp/app/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    component: () => import("/var/www/vhosts/asoundeffect.com/int-httpdocs/nuxt-wp/app/pages/login.vue")
  },
  {
    name: "uri",
    path: "/:uri(.*)*",
    component: () => import("/var/www/vhosts/asoundeffect.com/int-httpdocs/nuxt-wp/app/pages/[...uri].vue")
  },
  {
    name: "checkout",
    path: "/checkout",
    component: () => import("/var/www/vhosts/asoundeffect.com/int-httpdocs/nuxt-wp/app/pages/checkout.vue")
  },
  {
    name: "not-found",
    path: "/not-found",
    component: () => import("/var/www/vhosts/asoundeffect.com/int-httpdocs/nuxt-wp/app/pages/not-found.vue")
  },
  {
    name: my_45account3NRqaBndITRnxshN0T8SbNqzvrVqA1Et9Elgh_MjTx4Meta?.name,
    path: "/my-account",
    component: () => import("/var/www/vhosts/asoundeffect.com/int-httpdocs/nuxt-wp/app/pages/my-account.vue"),
    children: [
  {
    name: "my-account",
    path: "",
    component: () => import("/var/www/vhosts/asoundeffect.com/int-httpdocs/nuxt-wp/app/pages/my-account/index.vue")
  },
  {
    name: "my-account-address",
    path: "address",
    component: () => import("/var/www/vhosts/asoundeffect.com/int-httpdocs/nuxt-wp/app/pages/my-account/address.vue")
  },
  {
    name: "my-account-downloads",
    path: "downloads",
    component: () => import("/var/www/vhosts/asoundeffect.com/int-httpdocs/nuxt-wp/app/pages/my-account/downloads.vue")
  },
  {
    name: "my-account-favorites",
    path: "favorites",
    component: () => import("/var/www/vhosts/asoundeffect.com/int-httpdocs/nuxt-wp/app/pages/my-account/favorites.vue")
  },
  {
    name: "my-account-orders-id",
    path: "orders/:id()",
    component: () => import("/var/www/vhosts/asoundeffect.com/int-httpdocs/nuxt-wp/app/pages/my-account/orders/[id].vue")
  },
  {
    name: "my-account-address-form",
    path: "address-form",
    component: () => import("/var/www/vhosts/asoundeffect.com/int-httpdocs/nuxt-wp/app/pages/my-account/address-form.vue")
  },
  {
    name: "my-account-orders",
    path: "orders",
    component: () => import("/var/www/vhosts/asoundeffect.com/int-httpdocs/nuxt-wp/app/pages/my-account/orders/index.vue")
  },
  {
    name: "my-account-account-details",
    path: "account-details",
    component: () => import("/var/www/vhosts/asoundeffect.com/int-httpdocs/nuxt-wp/app/pages/my-account/account-details.vue")
  },
  {
    name: "my-account-payment-methods",
    path: "payment-methods",
    component: () => import("/var/www/vhosts/asoundeffect.com/int-httpdocs/nuxt-wp/app/pages/my-account/payment-methods.vue")
  },
  {
    name: "my-account-add-payment-method",
    path: "add-payment-method",
    component: () => import("/var/www/vhosts/asoundeffect.com/int-httpdocs/nuxt-wp/app/pages/my-account/add-payment-method.vue")
  },
  {
    name: "my-account-subscriptions-id",
    path: "subscriptions/:id()",
    component: () => import("/var/www/vhosts/asoundeffect.com/int-httpdocs/nuxt-wp/app/pages/my-account/subscriptions/[id].vue")
  },
  {
    name: "my-account-subscriptions",
    path: "subscriptions",
    component: () => import("/var/www/vhosts/asoundeffect.com/int-httpdocs/nuxt-wp/app/pages/my-account/subscriptions/index.vue")
  }
]
  },
  {
    name: "lost-password",
    path: "/lost-password",
    component: () => import("/var/www/vhosts/asoundeffect.com/int-httpdocs/nuxt-wp/app/pages/lost-password.vue")
  },
  {
    name: "create-account",
    path: "/create-account",
    component: () => import("/var/www/vhosts/asoundeffect.com/int-httpdocs/nuxt-wp/app/pages/create-account.vue")
  },
  {
    name: "category-uri",
    path: "/category/:uri(.*)*",
    component: () => import("/var/www/vhosts/asoundeffect.com/int-httpdocs/nuxt-wp/app/pages/category/[...uri].vue")
  },
  {
    name: "product-tag-uri",
    path: "/product-tag/:uri(.*)*",
    component: () => import("/var/www/vhosts/asoundeffect.com/int-httpdocs/nuxt-wp/app/pages/product-tag/[...uri].vue")
  },
  {
    name: "sound-library-uri",
    path: "/sound-library/:uri(.*)*",
    component: () => import("/var/www/vhosts/asoundeffect.com/int-httpdocs/nuxt-wp/app/pages/sound-library/[...uri].vue")
  },
  {
    name: "sounddesigner-uri",
    path: "/sounddesigner/:uri(.*)*",
    component: () => import("/var/www/vhosts/asoundeffect.com/int-httpdocs/nuxt-wp/app/pages/sounddesigner/[...uri].vue")
  },
  {
    name: "sound-category-uri",
    path: "/sound-category/:uri(.*)*",
    component: () => import("/var/www/vhosts/asoundeffect.com/int-httpdocs/nuxt-wp/app/pages/sound-category/[...uri].vue")
  }
]